import React, { Component } from "react";
import PropTypes from 'prop-types';
class FieldErrorShowModal extends Component {
  render() {
    const {
      modalId = "fieldErrorShowModel",
      logoSrc = "images/modal-logo.svg",
      errorCount = "",
      requiredFieldCount = "",
      LabelNames = [],
      stylingForMissingFieldsList,
      analyticsClickEvent
    } = this.props;

    return (
      <dialog className="modal fade model-error" id={modalId} tabIndex="-1" data-keyboard="false" data-backdrop="static" aria-labelledby={`${modalId}Label`} aria-hidden="true">
        <div className="modal-dialog" >
          <div className="modal-content">
            <div className="modal-header">
            </div>
            <div className="modal-body">
              <div className="logo">
                <img src={logoSrc} alt="logo" className="img-fluid" />
              </div>
              <div>
                <p className="text-center mt-4">There are <b>{errorCount}</b> required fields that are either blank or incorrect. Please check again.</p>
                {errorCount <= 3 &&
                  <div className='missing-fields'>
                    {requiredFieldCount != 0 &&
                      <h5 className="text-center mt-1 modal-title">Missing Fields</h5>
                    }
                    {LabelNames != undefined && <ul className='pl-0'>
                      {
                        LabelNames?.map((response, index) =>
                          <li className={`text-left mt-4 ${stylingForMissingFieldsList()}`} key={response.toString()}>{response}</li>)
                      }
                    </ul>
                    }
                  </div>
                }
              </div>
            </div>
            <div className="modal-footer mb-4">
              <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={(e) => analyticsClickEvent('fieldErrorShowModel')}>Ok</button>
            </div>
          </div>
        </div>
      </dialog>
    );
  }
}
FieldErrorShowModal.propTypes = {
  modalId: PropTypes.string,
  logoSrc: PropTypes.string,
  errorCount: PropTypes.any,
  required: PropTypes.any,
  LabelNames: PropTypes.array,
  stylingForMissingFieldsList: PropTypes.func,
  analyticsClickEvent: PropTypes.func,
  requiredFieldCount: PropTypes.any,
}
export default FieldErrorShowModal;